<template>
    <b-container
            class="relais mx-lg-auto px-0 d-flex flex-column"
    >
        <coach-roadlog
                class="mb-2"
        />
        <div
                class="mt-md-5"
                :class="{'px-md-5': mode === 'full'}"
        >
            <b-row class="no-gutters-mobile">
                <b-col
                        v-if="mode === 'full'"
                        cols="12"
                        md="6"
                >
                    <ae-block
                            type="header"
                            :class="{'mt-2': mode === 'full'}"
                    >
                        <h5>Mes prochaines séances</h5>
                    </ae-block>
                    <div>
                        <ae-block
                                v-if="nextMeetings.length === 0"
                                type="placeholder"
                                class="mt-2"
                        >
                            <p class="my-0">Vous n'avez pas de prochaine séance.</p>
                        </ae-block>
                        <router-link
                                v-for="(nextMeeting, i) in nextMeetings"
                                :key="i + '-nextMeeting'"
                                :to="{ name: 'meeting', params: { id: nextMeeting.id } }"
                        >
                            <ae-block class="card-style mb-2">
                                <div class="d-flex justify-content-between align-items-center px-1">
                                    <div class="d-flex justify-content-start align-items-center py-2">
                                        <b-img
                                                height="25"
                                                width="25"
                                                :src="icon(nextMeeting)"
                                                @error="$event.target.src = '/static/img/activities/white/default.png'"
                                        />
                                        <div class="d-flex flex-column pl-2">
                                            <b>{{ fullCreneauName(nextMeeting) }}</b>
                                            <span>{{ moment(nextMeeting.dateheure.date).calendar() }}</span>
                                        </div>
                                    </div>
                                    <div class="text-right d-flex flex-column">
                                        <b>
                                            {{ moment(nextMeeting.dateheure.date).format('H:mm') }}
                                            -
                                            {{
                                            moment(nextMeeting.dateheure.date).add(nextMeeting.duration,
                                            'm').format('H:mm')
                                            }}
                                        </b>
                                        <span>{{ nextMeeting.lieu }}</span>
                                    </div>
                                </div>
                            </ae-block>
                        </router-link>
                    </div>
                </b-col>
                <b-col
                        class=""
                        cols="12"
                        :md="mode === 'full' ? 6 : 12"
                >
                    <ae-block
                            type="header"
                            :class="{'br-3': mode === 'light', 'mt-2': mode === 'full'}"
                    >
                        <h5>Rappels</h5>
                    </ae-block>
                    <div>
                        <ae-block
                                v-if="todoList.length === 0"
                                type="placeholder"
                                class="mt-2"
                        >
                            <p class="my-0">Vous n'avez aucune tâche à faire.</p>
                        </ae-block>
                        <ae-block
                                v-for="(todo, index) of todoList"
                                :key="`coach-todo-${index}`"
                                class="card-style mb-2"
                        >
                            <coach-todo
                                    :todo="todo"
                            />
                        </ae-block>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<style lang="scss" scoped>

    .card-style {
        background-color: white;
        box-shadow: -1px 5px 5px -4px lightgray;
        padding: 0.2em 0.5em 0.2em 0.5em;
    }

    @media (max-width: 768px) {
        .no-gutters-mobile {
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
        .col-12 {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
</style>
<script>
    import moment from 'moment'

    import AeHero from '@/components/Hero'
    import AeBlock from "../components/Block";
    import NotificationContainer from "../components/NotificationContainer";
    import CoachTodo from "../components/CoachTodo";
    import CoachRoadlog from "@/views/coach/RoadlogInfo";

    export default {
        name: 'Roadlog',
        props: {
            mode: {
                default: 'full',
                type: String
            }
        },
        components: {
            CoachTodo,
            NotificationContainer,
            AeBlock,
            AeHero,
            CoachRoadlog
        },
        async mounted() {
            await Promise.all([
                this.$store.dispatch('base/meeting/nextAsCoach', {maxResults: 3}),
                this.$store.dispatch('base/account/todoList')
            ])
        },
        data: () => ({
            moment
        }),
        methods: {
            fullCreneauName(creneau) {
                if (creneau.nom === 'null' || !creneau.nom)
                    return `${creneau.activite.typeactivite.name} ${creneau.activite.name}`
                return `${creneau.activite.typeactivite.name} ${creneau.activite.name} ${creneau.name}`
            },
            icon(creneau) {
                return this.$store.getters['base/activity/getTypeActivityIcon'](creneau.activite.typeactivite, 'blue')
            }
        },
        computed: {
            user() {
                return this.$store.state.base.account.information
            },
            nextMeetings() {
                let meetings = this.$store.getters['base/meeting/future'].filter((meeting) => {
                    return moment(meeting.dateheure.date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY');
                });
                if (meetings.length === 0) {
                    meetings = this.$store.getters['base/meeting/future'].filter((meeting) => {
                        return moment(meeting.dateheure.date).format('DD/MM/YYYY') === moment().add(1, 'day').format('DD/MM/YYYY');
                    });
                }
                return this.$store.getters['base/meeting/future'].sort((a, b) => {
                    const aDate = moment(a.dateheure.date)
                    const bDate = moment(b.dateheure.date)
                    return (aDate > bDate) ? 1 : ((aDate < bDate) ? -1 : 0)
                })
            },
            todoList() {
                return this.$store.state.base.account.todoList
            }
        }
    }
</script>
